import { CACHE_PROFILES } from "@/config/query-cache"
import { useTransportQuery } from "@/transport"

import type { ListMetricDirectoryResponse } from "@/types_api/backend/transport/list_metric_directory_response"

interface UseMetricDirectoryTransportOptions<TData> {
  enabled?: boolean
  select?: (data: ListMetricDirectoryResponse) => TData
}

export function useMetricDirectoryTransport<
  TData = ListMetricDirectoryResponse,
>(options?: UseMetricDirectoryTransportOptions<TData>) {
  return useTransportQuery({
    operation: "listMetricDirectory",
    options: {
      ...CACHE_PROFILES.lookup,
      enabled: options?.enabled,
      select: (response) =>
        options?.select ? options.select(response) : (response as TData),
    },
  })
}
